module.exports = __webpack_public_path__ + "img/solomon.7393f0df.png";